export function initVideoHandler() {
  openVideoFromHash();
  initCopyFileListener();
}

function openVideoFromHash() {
  const videoHash = window.location.hash.split('video=');
  if (videoHash.length > 1) {
    const videoId = videoHash[1];
    const videoElement: HTMLElement | null = document.querySelector(`.js-videoLightbox[data-id="${videoId}"]`);

    if (videoElement) {
      videoElement.click();
    }
  }
}

function initCopyFileListener() {
  const copyElements: NodeListOf<HTMLElement> = document.querySelectorAll('.js-copyLink');

  copyElements.forEach((copyElement) => {
    copyElement.addEventListener('click', (event) => {
      event.stopImmediatePropagation();
      const copyIconClass = 'icon--copy';
      const checkIconClass = 'icon--check';
      const copyDoneClass = 'copyLink--done';
      const videoLink = copyElement.dataset.link || '';
      if (!copyElement.parentElement) {
        return;
      }
      const textElement: HTMLElement | null = copyElement.querySelector('.js-copyText');
      if (!textElement) {
        return;
      }

      /* copy video url to clipboard */
      navigator.clipboard.writeText(videoLink)
        .catch((error) => {
          console.error(error);
          textElement.innerText = copyElement.dataset.errorText || 'error';
        })
        .finally(() => {
          /* trigger animations for icons */
          copyElement.classList.remove(copyIconClass);
          copyElement.classList.add(checkIconClass);
          copyElement.classList.add(copyDoneClass);
          textElement.innerHTML = textElement.dataset.copyDoneText || '';

          window.setTimeout(
              () => {
                copyElement.classList.remove(copyDoneClass);

                // change icon after fade animation is done for smooth transition
                window.setTimeout(
                  () => {
                    copyElement.classList.remove(checkIconClass);
                    copyElement.classList.add(copyIconClass);
                    textElement.innerHTML = textElement.dataset.copyText || '';
                  },
                  1000,
                );
              },
              1000,
            );
        });
    });
  });
}
